import React from 'react';
import styled from 'styled-components';

import ContentfulImage from 'hub/components/ContentfulImage';

function CountryImage({ fields }) {
  return (
    <ImageWrapper>
      <ContentfulImage
        alt={fields.title}
        width={379}
        height={210}
        src={{ fields }}
        layout="responsive"
      />
    </ImageWrapper>
  );
}

const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: ${(props) => props.theme.spacing(1.5)}px;
`;

export default CountryImage;
